import { FONT, COLORS } from "../../styles";

export default function SectionHeader({ title, badge }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
      <span style={{ fontSize: 13, fontWeight: 600, color: COLORS.text, fontFamily: FONT }}>{title}</span>
      {badge && <span style={{ fontSize: 11, background: COLORS.redLight, color: COLORS.red, padding: "2px 8px", borderRadius: 6, fontWeight: 500, fontFamily: FONT }}>{badge}</span>}
    </div>
  );
}
